module.exports = __webpack_public_path__ + "dist/assets/redesign/ui/components/intro/img/intro-screen-3@3x__aa3d95af2f895aab6090a21efdf668e2.png";